<template>
  <v-container fluid class="px-0">
    <div class="salesorder-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-text>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="rhead">
                    {{ initvalue.salesordertype }} {{ initvalue.salesordernum }}
                  </p>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2" align="right">
                  <v-btn color="success" class="button-shadow" @click="Done">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Num</td>
                        <td>{{ initvalue.salesordernum }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Date</td>
                        <td>{{ new Date(initvalue.salesorderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Name</td>
                        <td>{{ initvalue.salesordername }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Address</td>
                        <td class="tcell">{{ initvalue.salesorderaddress }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Phone</td>
                        <td>{{ initvalue.salesorderphone }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Mobile</td>
                        <td>{{ initvalue.salesorderphone }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Note</td>
                        <td class="tcell">{{ initvalue.salesordernote }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-items'"
                    >
                      Items
                    </v-tab>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-files'"
                    >
                      Files
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-images'"
                    >
                      Images
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-items'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            loading-text="Loading... Please wait"
                            item-key="_id"
                            :footer-props="footer"
                            :headers="headers"
                            :items="transactions"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.itemimage="{ item }">
                              <v-img
                              v-if="item.itemimage" 
                              v-bind:src="item.itemimage"
                              max-height="100"
                              max-width="100"
                            ></v-img>
                            </template>
                            <template v-slot:item.itemamount="{ item }">
                              <p class="two-line">{{ item.itemamount.toFixed(2) }}</p>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="2"
                      :value="'tab-files'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            :headers="fileHeaders"
                            :items="files"
                            :items-per-page="100"
                            class="elevation-0"
                          >
                            <template v-slot:item.filetype="{ item }">
                              <a
                                v-if="item.filetype == 'pdf'"
                                :href="item.fileurl"
                                style="text-decoration: none !important"
                              >
                                <v-icon size="50" color="primary">
                                  mdi-file-pdf-box
                                </v-icon></a
                              >
                            </template>
                            <template v-slot:item.filesize="{ item }">
                              {{ (item.filesize / 1000).toFixed(0) + " KB" }}
                            </template>
                            <template v-slot:item.createdAt="{ item }">
                              {{
                                new Date(item.createdAt).toLocaleString(
                                  "en-SG",
                                  {
                                    year: "numeric",
                                    month: "numeric",
                                    day: "numeric",
                                  }
                                )
                              }}
                            </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="previewFile(item)"
                          >
                            <v-icon>mdi-text-box-search</v-icon>
                          </v-btn>
                        </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="3"
                      :value="'tab-images'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-container
                        class="fill-height"
                        fluid
                        style="min-height: 434px"
                      >
                        <v-fade-transition mode="out-in">
                          <v-row>
                            <v-col cols="4">
                              <v-card
                              v-for="image in images" :key="image._id"
                              :ripple="{class: 'ripple-color' }"
                              @click="clickImage(image)"
                              >
                                <v-img
                                  :src="image.imageurl"
                                  height="300"
                                  cover
                                  class="bg-grey-lighten-4"
                                  
                                ></v-img>
                                <v-card-title class="text-h8">
                                  {{ image.imagename }}
                                </v-card-title>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-fade-transition>
                      </v-container>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div class="text-center">
    <v-dialog
      v-model="showImageDialog"
      width="500px"
    >
      <v-card class="mx-1 mb-1">
        <v-card-text>
          
          <v-row v-if="image">
            <v-col cols="12">
              <v-img
              max-width="500px"
              cover
              :src="image.imageurl"
            ></v-img> 
            </v-col>

          </v-row>
      
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="showImageDialog = false"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "@/config";
import { mapState, mapActions } from 'vuex'

export default {
  name: "Profile",

  data() {
    return {
      config,
      initvalue: {},
      transactions: [],
      files: [],
      images: [],
      selectedTab: "1",
      showImageDialog: false,
      image: null,
      headers: [
        { text: 'Image', value: 'itemimage', width: '5%' },
        { text: 'Name', value: 'itemname' },
        { text: 'Price ', value: 'itemprice', width: '8%'},
        { text: 'Foc ', value: 'itemfoc' },
        { text: 'Quantity ', value: 'itemquantity', width: '8%' },
        { text: 'Amount', value: 'itemamount', width: '8%' },
      ],
      fileHeaders: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
    };
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
  },
  methods: {
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions("File", ["getSalesOrderFiles"]),

    clickImage(image){
      this.image = image;
      this.showImageDialog = true;
    },
    previewFile(item){
      let params = Object.assign({}, this.initvalue);
      params.fileurl = item.fileurl;
      params.isFromSalesOrder = true;
      this.$router.push({ name: "FilePreview", params: params })
    },
    Done() {
      if(this.initvalue._isFrom!==undefined) this.$router.replace({ name: this.initvalue._isFrom });
      else this.$router.replace({ name: 'Dashboard' });
    },
  },
  async created() {
    this.initvalue = this.$route.params;    
    if (!this.initvalue._id) this.$router.push({ name: "SalesOrderList" });
    console.log(this.initvalue)
    this.transactions = this.initvalue.transactions;
    this.files = this.initvalue.files;
    this.images = this.initvalue.images;
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.employees.length==0) await this.getEmployeesRequest();
    if(this.initvalue.isFromFiles==true) {this.$refs.filesTab.$el.click()}
  },
};
</script>

<style src="./View.scss" lang="scss"/>
